import { gql } from '@apollo/client';

export const ADD_ALERT = gql`
    mutation CreateAlert($createAlertInput: CreateAlertInput!) {
        createAlert(input: $createAlertInput) {
            alert {
                match
                calendarInstances {
                    calendar {
                        id
                    }
                }
                id
                invert
                pattern
                name
                enabled
                categories
                venues
                location
                priority
                enablePrm
                reminderTimes
                saveReminderAsDraft
                npsRecipients
                npsFrequency
                notifications {
                    id
                    interval
                    period
                    relativeTo
                    channel
                    createdAt
                    updatedAt
                }
                synonyms {
                    id
                    pattern
                    invert
                }
                createdAt
                updatedAt
            }
            errors {
                path
                message
            }
        }
    }
`;

export const DELETE_ALERT = gql`
    mutation DeleteAlert($deleteAlertInput: DeleteAlertInput!) {
        deleteAlert(input: $deleteAlertInput) {
            alert {
                id
            }
        }
    }
`;

export const UPDATE_ALERT = gql`
    mutation UpdateAlert($updateAlertInput: UpdateAlertInput!) {
        updateAlert(input: $updateAlertInput) {
            alert {
                match
                calendarInstances {
                    calendar {
                        id
                    }
                }
                id
                invert
                pattern
                categories
                venues
                location
                priority
                enablePrm
                reminderTimes
                saveReminderAsDraft
                npsRecipients
                npsFrequency
                name
                enabled
                notifications {
                    id
                    interval
                    period
                    relativeTo
                    channel
                    createdAt
                    updatedAt
                }
                synonyms {
                    id
                    pattern
                    invert
                }
                createdAt
                updatedAt
            }
            errors {
                path
                message
            }
            clientMutationId
        }
    }
`;

export const FETCH_CALENDARS = gql`
    query WritableCalendarInstances {
        user {
            calendarInstances(writable: true) {
                id

                effectiveLabel

                visible

                primary
                writable

                account {
                    id
                    name
                    email

                    enabled
                    active
                    authorized
                }

                calendar {
                    id
                }

                createdAt
                updatedAt
            }
        }
    }
`;

export const FETCH_ALERTS = gql`
    query Alerts($id: ID) {
        user {
            alerts(id: $id) {
                match
                calendarInstances {
                    id

                    effectiveLabel

                    visible

                    writable
                    primary

                    calendar {
                        id
                    }

                    createdAt
                    updatedAt
                }
                id
                invert
                pattern
                position
                categories
                venues
                location
                priority
                enablePrm
                reminderTimes
                saveReminderAsDraft
                npsRecipients
                npsFrequency
                name
                enabled
                notifications {
                    id
                    interval
                    period
                    relativeTo
                    channel
                    createdAt
                    updatedAt
                }
                synonyms {
                    id
                    pattern
                    invert
                }
                createdAt
                updatedAt
            }
        }
    }
`;

export const UPDATE_ALERTS_ORDER = gql`
    mutation UpdateAlertPositions($updateAlertPositionsInput: UpdateAlertPositionsInput!) {
        updateAlertPositions(input: $updateAlertPositionsInput) {
            alerts {
                match
                calendarInstances {
                    id

                    effectiveLabel

                    visible

                    writable
                    primary

                    calendar {
                        id
                    }

                    createdAt
                    updatedAt
                }
                id
                invert
                name
                enabled
                pattern
                position
                categories
                venues
                location
                priority
                enablePrm
                reminderTimes
                saveReminderAsDraft
                npsRecipients
                npsFrequency
                notifications {
                    id
                    interval
                    period
                    relativeTo
                    channel
                    createdAt
                    updatedAt
                }
                synonyms {
                    id
                    pattern
                    invert
                }
                createdAt
                updatedAt
            }
            errors {
                path
                message
            }
            clientMutationId
        }
    }
`;
